import defaultReducer from "./defaultReducer";

export const initialState = {
  filterData: {
    operator: [],
    manufacturer: [],
    machinetypes: [],
    game: [],
    regions: [],
  },
  filterActive: {
    directory: true,
    manufacturer: false,
    game: false,
    machinetypes: false,
    regions: false,
    search: false,
  },
  filterSelected: {
    company: { id: null },
    subcompany: { id: null },
    site: { id: null },
    searchText: "",
    operator: null,
    regions: [],
    manufacturer: [],
    machinetypes: [],
    game: [],
  },
  organisations: [],
  allOrgsActive: true,
  activeOrgs: [],
  activeSubOrgs: [],
  hasSelection: false,
  operatorOptions: {},
  showOrgTree: true,
};

export const transactionsFiltersReducer = defaultReducer(
  "FETCH_TRANSACTIONS_FILTERS",
  initialState,
);
export const installationsFiltersReducer = defaultReducer(
  "FETCH_INSTALLATIONS_FILTERS",
  initialState,
);
export const sessionsFiltersReducer = defaultReducer(
  "FETCH_SESSIONS_FILTERS",
  initialState,
);
export const LiveFloorViewerFiltersReducer = defaultReducer(
  "FETCH_LIVE_FLOOR_VIEWER_FILTERS",
  initialState,
);
export const collectionsFiltersReducer = defaultReducer(
  "FETCH_COLLECTIONS_FILTERS",
  initialState,
);
export const settingsFiltersReducer = defaultReducer(
  "FETCH_SETTINGS_FILTERS",
  initialState,
);
export const kioskFiltersReducer = defaultReducer(
  "FETCH_KIOSK_FILTERS",
  initialState,
);
export const analysisFiltersReducer = defaultReducer(
  "FETCH_ANALYSIS_FILTERS",
  initialState,
);
export const complianceFiltersReducer = defaultReducer(
  "FETCH_COMPLIANCE_FILTERS",
  initialState,
);
export const customerFiltersReducer = defaultReducer(
  "FETCH_CUSTOMER_FILTERS",
  initialState,
);
